import { useMsal } from '@azure/msal-react';
import { useEffect, useCallback, useState } from 'react';
import { loginRequest } from '../../utils/authConfig';
import './Login.less';
import { POSImage } from '@publicisgroupe/p-os-components';
import { LoginMobileView } from './LoginMobileView';
import { LoginDesktopView } from './LoginDesktopView';
import { useLocation } from 'react-router-dom';
import { LOGIN_CALLBACK_ROUTE_KEY } from '../../utils/constants';
import { useLoginPageImages } from 'hooks/useLoginPageImages';

export const Login = () => {
  const { instance } = useMsal();
  const [showLandscape, setShowLandscape] = useState<boolean>(true);
  const [showLogo, setShowLogo] = useState<boolean>(false);
  const [showLoginBackground, setShowLoginBackground] = useState<boolean>(false);
  const [showLoginContent, setShowLoginContent] = useState<boolean>(false);
  const location = useLocation();

  const pageImages = useLoginPageImages();

  const loginRedirect = useCallback(() => {
    localStorage.setItem(LOGIN_CALLBACK_ROUTE_KEY, location.pathname);
    instance.loginRedirect(loginRequest).catch(console.error);
  }, [instance, location.pathname]);

  useEffect(() => {
    setTimeout(() => {
      setShowLogo(true);
      setTimeout(() => {
        setShowLoginBackground(true);
        setShowLandscape(false);
        setShowLogo(false);
        setTimeout(() => {
          setShowLoginContent(true);
        }, 500);
      }, 2000);
    }, 1500);
  }, []);

  return (
    <div className="login-page">
      <div className={showLoginBackground ? 'hide-background' : ''}>
        <div className={showLandscape ? 'fadeIn' : 'fadeOutSlow'}>
          <div
            className="sunset-bg header-bg"
            style={{
              backgroundImage: pageImages.splashScreenBackgroundImage,
            }}
          />
        </div>
      </div>

      <div className={`logo-section ${showLoginBackground ? 'hide-background' : ''}`}>
        <div className={showLogo ? 'logo-fadeIn' : 'logo-fadeOut'}>
          <POSImage
            src={pageImages.splashScreenLogo}
            className="logo-primary-dark-bg-before"
            alt="PGOS Logo"
          />
        </div>
      </div>
      {/*  mobile view */}
      <LoginMobileView
        showLandscape={showLandscape}
        showLoginBackground={showLoginBackground}
        showLoginContent={showLoginContent}
        backgroundImage={pageImages.mobileViewBackgroundImage}
        loginRedirect={loginRedirect}
      />
      {/* desktop view */}
      <LoginDesktopView
        showLandscape={showLandscape}
        showLoginBackground={showLoginBackground}
        showLoginContent={showLoginContent}
        backgroundImage={pageImages.desktopViewBackgroundImage}
        posLogo={!pageImages.isClientLogin ? pageImages.desktopViewLogo : undefined}
        logo={pageImages.isClientLogin ? pageImages.desktopViewLogo : undefined}
        loginRedirect={loginRedirect}
      />
    </div>
  );
};
